import { LinkProps } from 'next/dist/client/link'
import Link from 'next/link'
import { forwardRef, ReactNode } from 'react'

export type NextLinkProps = LinkProps & { target?: string; title?: string; children?: ReactNode }

export const NextLink = forwardRef<HTMLAnchorElement, NextLinkProps>(function (props, ref) {
  return (
    <Link ref={ref} {...props}>
      {props.children}
    </Link>
  )
})
